import { createResource } from 'redux-rest-resource'
import { baseURL } from '.'
import {
  cloneDeep,
  defaultTo,
  get,
  includes,
  map,
  remove,
  toNumber
} from 'lodash'

export const { types, actions, rootReducer } = createResource({
  name: 'preventionPlan',
  pluralName: 'preventionPlans',
  url: `${baseURL}/pdp`,
  credentials: 'include',
  actions: {
    fetch: {
      method: 'GET',
      gerundName: 'fetching',
      url: '.?limit=1000',
      reduce: (state, { body, status }) => {
        if (status === 'pending' || status === 'rejected') {
          return { ...state, isFetching: status === 'pending' }
        } else if (status === 'resolved') {
          const _preventionPlans = body?.results || []
          return { ...state, items: _preventionPlans, isFetching: false }
        }
        return state
      }
    },
    fetchAvenants: {
      method: 'GET',
      gerundName: 'fetchingAvenants',
      url: './all',
      reduce: (state, { body, status }) => {
        if (status === 'pending' || status === 'rejected') {
          return { ...state, isFetchingAvenants: status === 'pending' }
        } else if (status === 'resolved') {
          const avenantsPdp = body || []
          return {
            ...state,
            avenants: avenantsPdp,
            isFetchingAvenants: false
          }
        }
        return state
      }
    },
    get: { method: 'GET', gerundName: 'getting', url: './:id' },
    create: {
      method: 'POST',
      gerundName: 'creating',
      url: '.'
    },
    update: {
      method: 'PUT',
      gerundName: 'updating',
      url: './:id',
      assignResponse: true,
      reduce: ({ items, item, ...state }, { body: updatedItem, status }) => {
        const { id } = item
        const isUpdating = status === 'pending'

        if (status === 'resolved') {
          item = updatedItem
          items = map(items, _item =>
            get(_item, 'id') === id ? updatedItem : _item
          )
        }

        return { ...state, items, item, isUpdating }
      }
    },
    delete: {
      method: 'DELETE',
      gerundName: 'deleting',
      url: './:id',
      reduce: ({ items, ...state }, { context: deletedItem, status }) => {
        if (status === 'resolved') {
          // Suppression des donnÃ©es archivÃ©es du store
          remove(items, {
            id: defaultTo(get(deletedItem, 'id'), toNumber(deletedItem))
          })
        }

        return { ...state, items: cloneDeep(items) }
      }
    },
    deleteMany: {
      isArray: true,
      alias: 'delete',
      method: 'DELETE',
      gerundName: 'deleting',
      url: './delete',
      reduce: ({ items, ...state }, { context: deletedItems, status }) => {
        if (status === 'resolved') {
          // Suppression des donnÃ©es archivÃ©es du store
          remove(items, ({ id }) =>
            includes(
              map(deletedItems, deletedItem =>
                defaultTo(get(deletedItem, 'id'), toNumber(deletedItem))
              ),
              toNumber(id)
            )
          )
        }

        return { ...state, items: cloneDeep(items) }
      }
    }
  }
})
